module.exports = __webpack_public_path__ + "img/es.fed7d0ce.png";